import { useEffect } from "react";
import { useSystemSettings } from "./useSystemSettings";

/**
 * Applies SEO meta tags from system_settings.
 * Now uses the shared batch query instead of a separate Supabase call.
 */
export function useSeoConfig() {
  const { data } = useSystemSettings();

  useEffect(() => {
    const cfg = data?.seo_config;
    if (!cfg) return;

    if (cfg.title) document.title = cfg.title;

    const setMeta = (selector: string, value: string, attr = "content") => {
      const el = document.querySelector(selector);
      if (el && value) el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]', cfg.description);
    setMeta('meta[name="keywords"]', cfg.keywords);
    setMeta('meta[name="author"]', cfg.author);
    setMeta('link[rel="canonical"]', cfg.canonicalUrl, "href");

    setMeta('meta[property="og:title"]', cfg.ogTitle);
    setMeta('meta[property="og:description"]', cfg.ogDescription);
    setMeta('meta[property="og:image"]', cfg.ogImage);
    setMeta('meta[property="og:url"]', cfg.ogUrl);
    setMeta('meta[property="og:site_name"]', cfg.ogSiteName);

    setMeta('meta[name="twitter:title"]', cfg.twitterTitle);
    setMeta('meta[name="twitter:description"]', cfg.twitterDescription);
    setMeta('meta[name="twitter:image"]', cfg.twitterImage);
    setMeta('meta[name="twitter:card"]', cfg.twitterCard);
  }, [data?.seo_config]);
}
